import { Injectable } from "@angular/core";
import { User } from "../models/auth.models";
import { account, ID } from "../config/appwrite";
import { UserService } from "./user.service";
import { PacientesService } from "./paciente.service";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: "root" })

/**
 * Auth-service Component
 */
export class AuthenticationService {
  user!: User;
  currentUserValue: any;

  constructor(
    private __userService: UserService,
    private __pacientesService: PacientesService,
    private http: HttpClient
  ) {}

  async login(email: string, password: string): Promise<any> {
    try {
      // Primero, intenta obtener la sesión actual
      const sessionActual = await account.get();
      // Si llega aquí, significa que hay una sesión activa
      // Cierra la sesión antes de iniciar una nueva
      await account.deleteSession("current");
    } catch (error) {
      // Si no hay sesión activa, ignoramos el error
      console.log("c");
    }

    try {
      // Crear la sesión de inicio de sesión
      const session = await account.createEmailPasswordSession(email, password);

      // console.log(session);

      // Obtener el rol del usuario
      const userRole = await this.__userService.getUserRole(session.userId);
      console.log(userRole);
      if (userRole.length > 0) {
        const currentUserValue = userRole[0];

        if (currentUserValue.role === "PACIENTE") {
          const paciente = await this.__pacientesService.getDocumentMinimal(
            currentUserValue.idUserRelation
          );
          const local = paciente.pais == "CO" ? true : false;
          return {
            role: currentUserValue.role,
            userId: currentUserValue.idUserRelation,
            userLoginId: currentUserValue.idUserLogin,
            nombre: paciente.nombres + " " + paciente.apellidos,
            local: local,
            pais: paciente.pais || paciente.idPaisResidencia || 'CO',
            idEmpresa: paciente.idEmpresa,
            idConvenio: paciente.idConvenio
          };
        } else {
          throw new Error("Usuario sin rol asociado");
        }
      }
      throw new Error("Usuario sin rol asociado");
    } catch (error) {
      console.error("Error durante el inicio de sesión:", error);
      throw error; // Lanzar el error para manejarlo fuera de la función
    }
  }

  getCurrentUser(): Promise<any> {
    // alert();
    if (this.currentUserValue) {
      return Promise.resolve(this.currentUserValue);
    } else {
      return this.getUser();
    }
  }

  getUser(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const promise = account.get();
      promise
        .then((response) => {
          this.currentUserValue = response;
          resolve(response);
        })
        .catch((error) => {
          console.error("Error obteniendo usuario:", error);
          reject(error);
        });
    });
  }

  /**
   * Logout the user
   */
  logout() {
    // logout the user
    localStorage.removeItem("currentPatient");
    this.currentUserValue = null;
    account.deleteSession("current");
  }

  /**
   * Reset password
   * @param email email
   */
  resetPassword(email: string) {
    const url = environment.urlSitePacientes + "account/change-password";
    const payload = {
      email: email,
      url: url,
    };

    return this.http.post(environment.apiStates + "/resetPassword", payload);
  }
  resetPassword_OLD(email: string) {
    console.log("recuperar");
    return account.createRecovery(
      email,
      environment.urlSitePacientes + "/account/change-password"
    );
  }

  /**
   * Change Password
   * @param userId
   * @param secret
   * @param password1
   * @param password2
   * @returns
   */
  changePassword(
    userId: string,
    secret: string,
    password1: string,
    password2: string
  ) {
    return account.updateRecovery(userId, secret, password1);
  }

  // DEBE EXSISTIR UNA SESION ACTIVA PARA HACER LO SIGUIENTE
  // En este caso el usuario debe estar logueado y si no se ha autenticado le mustra una alerta
  // Con la alerta él puede enviar el mail de validación

  async sendValidation() {
    await account
      .createVerification(
        environment.urlSitePacientes + "account/validate/" // url
      )
      .then((response: any) => {
        console.log("response::", response);
        return true;
      });
  }

  // TRAE LA INFORMACIÓN DE LA CUENTA ACTUAL
  async getValidation() {
    return await account.get();
  }

  async sendMailTest() {
    const result0 = await account.createEmailPasswordSession(
      "vijumx+32@gmail.com", // userId
      "12345678" // secret
    );
    console.log("createSession::", result0);

    const resultUrlVerification = await account
      .createVerification(
        environment.urlSitePacientes // url
      )
      .then((response: any) => {
        console.log("response::", response);
      });

    console.log("resultUrlVerification::", resultUrlVerification);

    //   const token = await account.('[USER_ID]');
    //   const secret = token.secret;

    // const resultVefirication = await account.updateVerification('66b226c60000742c74c3','');
    //  console.log("createSession::",resultVefirication);

    // const result4 = await account.createMagicURLToken(
    //   '66b226c60000742c74c3', // userId
    //   'vijumx+32@gmail.com', // email
    //   'https://nuvoll.com', // url (optional)
    //   false // phrase (optional)
    // );

    // console.log("createMagicURLToken::",result4);

    //     const result = await account.listSessions();

    // console.log("SESIONES:::: ",result);

    // const result2 = await account.createJWT();
    // console.log("createJWT:::: ",result2);
  }

  /*
  eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI2NmIyMjZjNjAwMDA3NDJjNzRjMyIsInNlc3Npb25JZCI6IjY2YjI0OWQ1NTYyOGI3MmZmM2Y5IiwiZXhwIjoxNzIyOTYxMjQxfQ.Zf4YS72Z9dtKXLhUC9oDbUawdKavOV-ScAPHHjErAm8
  
  66b226c60000742c74c3
  http://localhost:4300//account/change-password?userId=66b226c60000742c74c3&secret=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI2NmIyMjZjNjAwMDA3NDJjNzRjMyIsInNlc3Npb25JZCI6IjY2YjI0OWQ1NTYyOGI3MmZmM2Y5IiwiZXhwIjoxNzIyOTYxMjQxfQ.Zf4YS72Z9dtKXLhUC9oDbUawdKavOV-ScAPHHjErAm8&expire=2024-08-06+14%3A36%3A07.093

  
  */
}
